import { useTranslation } from 'react-i18next';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';
import { Globe } from 'lucide-react';

/**
 * Compact language switcher.
 *
 * Pass `langs` to control the visible options:
 *   <LanguageSwitcher langs={['fr', 'en']} />     // dentist
 *   <LanguageSwitcher langs={['en', 'zh']} />     // lab
 */
const LABELS = { fr: 'Français', en: 'English', zh: '中文' };

const LanguageSwitcher = ({ langs = ['fr', 'en'], className = '' }) => {
  const { i18n } = useTranslation();
  const current = langs.includes(i18n.language) ? i18n.language : langs[0];
  return (
    <Select value={current} onValueChange={(v) => i18n.changeLanguage(v)}>
      <SelectTrigger className={`w-[120px] h-8 ${className}`} data-testid="lang-switcher">
        <Globe className="h-3.5 w-3.5 mr-1" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {langs.map(l => (
          <SelectItem key={l} value={l} data-testid={`lang-${l}`}>{LABELS[l] || l}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
